const { v4 } = require('uuid');

export function GenerateUniqueID(){
    return v4();
}